<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15n4uVd/tc-custom/9781504060028.jpg?1705751375204" alt="This image is the cover for the book Dark Maze, The Neil Hockaday Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dark Maze, The Neil Hockaday Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Edgar Award Winner: An NYPD detective navigates a lethal labyrinth in this entry in Adcock’s series of “gritty procedurals” (<i>The New York Times Book Review</i>).</b><br/>  <br/> The old, shabbily dressed man who walks up to Neil Hockaday in the park one morning rambles on semicoherently, though he’s sharp enough to make Hockaday as a cop. He introduces himself as Picasso, makes snide comments about the policeman to an invisible companion—and issues a vague homicidal threat just before his bus leaves.<br/>  <br/> Born and bred in Hell’s Kitchen and now an NYPD detective, Hockaday has been exposed to plenty of strange characters. But Picasso’s haunting words—and the killings that follow—soon have the officer searching the city for someone who considers murder his masterpiece . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Adcock
      </h2>
      
      <p class="authorDescription body article">Thomas Adcock (b. 1947) is an Edgar Award&ndash;winning novelist and journalist from Detroit. Since 1985, Adcock has written over a dozen short stories and anthologies, in addition to his popular crime thrillers starring New York&ndash;based detective Neil Hockaday.&#160; Adcock was involved in PEN International, The Mystery Writers of America, and cofounded the North American chapter of the International Association of Crime Writers. He currently resides in New York.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c0fea572